var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef, useState } from "react";
import { GroupsMode } from "../../../Register";
import { Error, Form, IconButton } from "@brushfire/ui";
import { useDispatch, useSelector } from "react-redux";
import FormikContextListener from "../../../../../Helpers/FormikContextListener";
import Constants from "../../../../../../data/constants";
import * as Yup from "yup";
import { handleErrors } from "../../../../../../data/helpers";
import { resendGroupPasscode } from "../../../../../../data/api";
import { setFormIsSubmitting } from "../../../../../../store/AppState/actions";
import ReCAPTCHA from "react-google-recaptcha";
import WidgetFieldset from "../../../../../Helpers/WidgetFieldset";
import useWidgetHistory from "../../../../../../hooks/useWidgetHistory";
var useTypedSelector = useSelector;
var GroupJoin = function (_a) {
    var eventData = _a.eventData, path = _a.path, groupsMode = _a.groupsMode, setGroupsMode = _a.setGroupsMode;
    var groups = useTypedSelector(function (store) { return store.events; }).groups;
    var event = useTypedSelector(function (store) { return store.events; }).event;
    var _b = __read(useState(false), 2), showSuccess = _b[0], setShowSuccess = _b[1];
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var recaptchaRef = useRef();
    var onSubmit = function (values, formikHelpers) { return __awaiter(void 0, void 0, void 0, function () {
        var token, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    formikHelpers.setSubmitting(false);
                    return [4 /*yield*/, recaptchaRef.current.executeAsync()];
                case 1:
                    token = _b.sent();
                    values.recaptchaResponse = token;
                    formikHelpers.setSubmitting(true);
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    formikHelpers.setSubmitting(false);
                    recaptchaRef.current.reset();
                    formikHelpers.setFieldError("recaptchaResponse", "Recaptcha is required.");
                    return [2 /*return*/];
                case 3:
                    if (event) {
                        dispatch(setFormIsSubmitting(true));
                        resendGroupPasscode(event === null || event === void 0 ? void 0 : event.eventNumber, values.email, values.recaptchaResponse)
                            .then(function (_a) {
                            var data = _a.data;
                            setShowSuccess(true);
                            history.goBack();
                        })
                            .catch(function (err) {
                            var _a;
                            handleErrors(err, formikHelpers);
                            (_a = recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.reset();
                        })
                            .finally(function () {
                            dispatch(setFormIsSubmitting(false));
                            formikHelpers.setSubmitting(false);
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    if (!eventData || !groups) {
        return null;
    }
    var JoinSchema = Yup.object().shape({
        email: Yup.string()
            .email("Email is required")
            .required("Email is required"),
    });
    return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "d-flex align-items-center justify-content-between" }, { children: [_jsx("h4", __assign({ className: "semi-bold mb-0" }, { children: "Retrieve your group manager passcode" })), _jsx(IconButton, { ariaLabel: "Back to Group Choices", icon: "times", classes: "d-inline-flex m-left p-top-icon-3", onClick: function (evt) {
                            evt.stopPropagation();
                            evt.preventDefault();
                            if (!eventData.isGroupCentric) {
                                setGroupsMode(GroupsMode.hide);
                            }
                            else {
                                setGroupsMode(GroupsMode.buttons);
                            }
                            history.push((isAutoRegMode
                                ? Constants.Routes.autoreg
                                : eventData.verbiage === "Tickets"
                                    ? Constants.Routes.tickets
                                    : Constants.Routes.register)
                                .replace(":clientKey", eventData.clientKey)
                                .replace(":urlKey", eventData.urlKey)
                                .replace(":eventNumber", eventData.eventNumber.toString()));
                        } })] })), showSuccess ? (_jsx("h3", __assign({ className: "success" }, { children: "Thanks! We sent you an email with your manage passcode." }))) : (_jsx(_Fragment, { children: _jsx(Form, __assign({ initialValues: {}, onSubmit: onSubmit, validationSchema: JoinSchema, useUnsavedPrompt: path === Constants.Routes.resetGroup }, { children: function (_a) {
                        var formikContext = _a.formikContext;
                        return (_jsxs(_Fragment, { children: [_jsx(FormikContextListener, { currentPath: path, path: [Constants.Routes.resetGroup], formikContext: formikContext, active: path === Constants.Routes.resetGroup }), _jsxs(WidgetFieldset, { children: [_jsx(Form.Field, { label: "Email you used when you set up your group", id: "email", name: "email", type: "email", placeholder: "name@domain.com" }), _jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: Constants.RecaptchaSiteKey, onChange: function (value) {
                                                formikContext.setFieldValue("recaptchaResponse", value);
                                            }, size: "invisible" }), _jsxs("p", __assign({ className: "mini" }, { children: ["This site is protected by reCAPTCHA and the Google", " ", _jsx("a", __assign({ href: "https://policies.google.com/privacy" }, { children: "Privacy Policy" })), " and", " ", _jsx("a", __assign({ href: "https://policies.google.com/terms" }, { children: "Terms of Service" })), " apply."] })), formikContext.errors.recaptchaResponse && formikContext.submitCount > 0 && (_jsx(Error, { children: formikContext.errors.recaptchaResponse }))] })] }));
                    } })) }))] }));
};
export default GroupJoin;
